import   React                           ,
       { useEffect                       ,
         useState                        }  from "react";

import   classNames                         from 'classnames';

import   styles                             from './LiveStats.module.scss';

import   AnimatedWaitingIcon2               from '../../widget/animations/animatedWaitingIcon2';
import   Box                                from '../../widget/windows/Box';

import   UserInformations2                  from '../userManagment/UserInformations2'

import { groupData                       ,
         generateStats                   ,
         generateChartData               ,
         GroupedData                     ,
         ChartData                       ,
         initializedGroupedData          ,
         completeGroupData               }  from "../../../dataTypes/dataSetManagment/regroupData";

import { Coordinate                      }  from '../../../dataTypes/geolocationManagment/types';

import { convertDateToString             ,
         convertStringToDate             ,
         formatDurationInSeconds         ,
         timeStepNames                   ,
         timeStepTitles                  ,
		 roundDate                       }  from '../../../dataTypes/timeManagment/utils';

import { UserSession                     ,
         LiveSession                     ,
         GetSessionsParams               }  from '../../../dataTypes/customerFrontEventManagment/types';

import { getLiveSessions                 ,
		 computeSessionActivity          ,
         computeSessionActivityEvolution }  from '../../../dataTypes/customerFrontEventManagment/utils';

import { getBroadcastingChannelList      }  from '../../../backendServices/broadcastingManagment/api_broadcastingChannel';


import   CustomerFrontEventList             from "./CustomerFrontEventList";

interface LiveStatsProps {
  userEmail?        : string;
  userId?           : number;
  userCreationDate? : Date;
  height?           : string;
}

export const LiveStats: React.FC<LiveStatsProps> = ({ userEmail, userId , userCreationDate, height = "100vh"}) => {

  const now                 = new Date();
  const startOfYesterday    = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0);
  const startOfTomorrow     = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);

  const startOfTwoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1, 0, 0, 0);

  const [ liveSessionList           , setLiveSessionList           ] = useState<LiveSession[]>([]);
  const [ filteredLiveSessionList   , setFilteredLiveSessionList   ] = useState<LiveSession[]>([]);
  const [ coordinates               , setCoordinates               ] = useState<Coordinate[]>([]);
  
  const [ startDate                 , setStartDate                 ] = useState<Date | null>( (userId || userEmail) ? userCreationDate ?? null : startOfTwoMonthsAgo ?? null );
  const [ endDate                   , setEndDate                   ] = useState<Date | null>(startOfTomorrow);
  const [ filterName                , setFilterName                ] = useState("");
  const [ timeStep                  , setTimeStep                  ] = useState<string>("1 jour");
  const [ showWaitingIcon           , setShowWaitingIcon           ] = useState(false);
  const [ userToShow                , setUserToShow                ] = useState<number>(0);

  const [ groupedData               , setGroupedData               ] = useState<GroupedData<LiveSession>>(initializedGroupedData<LiveSession>()) 
  const [ chartData                 , setChartData                 ] = useState<ChartData[]>([])

  const [ broadcastingChannelsNames , setBroadcastingChannelsNames ] = useState<string[]>([]);


  const fetchLiveSessions = async (params: GetSessionsParams = {}) => {

    try
     {
      setShowWaitingIcon(true);

      const updatedParams: GetSessionsParams = {
        ...params,
        userEmail,
        userId,
        beginningDate : startDate ?? startOfYesterday,
        endingDate    : endDate   ?? startOfTomorrow
      };

      const sessions = await getLiveSessions(updatedParams);

      setLiveSessionList         (sessions);
	  setFilteredLiveSessionList (sessions);
	  
      const getBroadcastingChannelListResult = await getBroadcastingChannelList (false)

      if (getBroadcastingChannelListResult.code === 1)
       {
        let tab = getBroadcastingChannelListResult.payload
        let tabNames: string[] = []

        for (let num=0; num<tab.length; num++)
         {
		  tabNames.push (tab[num].name)
         }

        setBroadcastingChannelsNames(tabNames);
       }
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
    finally
     {
      setShowWaitingIcon(false);
   //   setRefreshCount(prev => prev + 1);  // Incrémente le compteur
     }
  };

  const getGroupKey = (timeStep: string) => {

    switch (timeStep)
      {
       case "1 minute"   : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "mm", 1), "yyyy/MM/dd HH:mm")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                            });

       case "5 minutes"  : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "mm", 5), "yyyy/MM/dd HH:mm")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                            });

       case "10 minutes" : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "mm", 1), "yyyy/MM/dd HH:mm")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                            });

       case "1 heure"    : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "HH", 1), "yyyy/MM/dd HH")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                            });

       case "6 heures"   : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "HH", 6), "yyyy/MM/dd HH")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                            });

       case "12 heures"  : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "HH", 12), "yyyy/MM/dd HH")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                            });


       case "1 jour"     : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "dd", 1), "yyyy/MM/dd")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                            });

       case "1 semaine"  : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "dd", 7), "yyyy/MM/dd")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                            });

       case "2 semaines" : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "dd", 14), "yyyy/MM/dd")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                            });

       case "1 mois"     : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "MM", 1), "yyyy/MM")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                            });

       case "6 mois"     : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "MM", 6), "yyyy/MM")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                            });

       case "1 an"       : return (session: LiveSession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "yyyy", 1), "yyyy")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy"), "yyyy")}`,
                                                            });

       default           : throw new Error(`Unsupported timeStep: ${timeStep}`);
      }
  };
 
  const getRenderer = (val: Date): string => {

    switch (timeStep)
      {
       case "1 minute"   : return `${convertDateToString(val, "HH:mm",'')}`
       case "5 minutes"  : return `${convertDateToString(val, "HH:mm",'')}`
       case "10 minutes" : return `${convertDateToString(val, "HH:mm",'')}`
       case "1 heure"    : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "6 heures"   : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "12 heures"  : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "1 jour"     : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 semaine"  : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "2 semaines" : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "6 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "1 an"       : return `${convertDateToString(val, "yyyy",'')}`
       default           : throw new Error(`Unsupported timeStep: ${timeStep}`)
      }
  };

  useEffect(() => {
    fetchLiveSessions();
  }, [userEmail, userId, startDate, endDate]);

  useEffect(() => {

    const coords = filteredLiveSessionList.map(session => ({
        lat   :    session.ipAddressLat  || 0,
        lng   :    session.ipAddressLon  || 0,
        info1 :    convertDateToString (session.startDate, 'dd/MM/yyyy HH:mm:ss' ), // session.ipAddress     || "N/A",
        info2 : `${session.userFirstname || "N/A"} ${session.userLastname || "N/A"}`,
		color : 'violet'
      }));

    setCoordinates(coords);

    const groupedDataTemp    = groupData<LiveSession> (filteredLiveSessionList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<LiveSession>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<LiveSession>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<LiveSession> ( completedGroupData , () => 1 , (a, b) => a + b );
    generateChartData<LiveSession> ( statsResult, completedGroupData);

    const now               = new Date ();
    const currentMonthStart = new Date (now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

    let audiencePeriodStartDate = startDate ?? currentMonthStart
    let audiencePeriodEndDate   = endDate   ?? now



    const temp = computeSessionActivityEvolution ( computeSessionActivity ( filteredLiveSessionList  as UserSession[] ) ,
                                                   timeStep                                                             ,
		                                           audiencePeriodStartDate                                              ,
							                       audiencePeriodEndDate                                                )

    const chart = temp.map ( d => {

      return {
        group: getRenderer ( d.date ),
        series: [ { name: 'data', value: d.activity } ]
      };
    });

    setGroupedData ( completedGroupData )
    setChartData (chart) // (chartDataTemp)

  }, [filteredLiveSessionList]);

  useEffect(() => {
	  
    const groupedDataTemp    = groupData<LiveSession> (filteredLiveSessionList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<LiveSession>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<LiveSession>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<LiveSession> ( completedGroupData , () => 1 , (a, b) => a + b );
    const chartDataTemp = generateChartData<LiveSession> ( statsResult, completedGroupData);

    setGroupedData ( completedGroupData )
    setChartData (chartDataTemp)

    console.log (timeStep, groupedDataTemp,completedGroupData,chartDataTemp)

  }, [timeStep]);
  
  const handleSpanClick = (userId:number) => {
	  
    console.log(`Affiche infos du user ${userId}`); // Add semicolon here

    setUserToShow (userId)
  }
  
  const handleClose = () => {
	  
    setUserToShow (0)
  }

  const handleDateRangeChange = (start: string, end: string) => {

    const date1 = convertStringToDate (start,'dd/MM/yyyy HH:mm');
    const date2 = convertStringToDate (end  ,'dd/MM/yyyy HH:mm');

    setStartDate (date1);
    setEndDate   (date2);
  };

  const handleTimeStepChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setTimeStep(e.target.value);
  };

  const filterLiveSession = ( filterName: string): LiveSession[] => {
	  
    let filteredSessionList = liveSessionList;

    if (filterName !== "") 
	 {
      const filterTextLowerCase = filterName.toLowerCase();

      filteredSessionList = liveSessionList.filter(
        (liveSession) =>
          liveSession.userId.toString().toLowerCase().includes(filterTextLowerCase) ||
          liveSession.userEmail.toLowerCase().includes(filterTextLowerCase) ||
          liveSession.userFirstname.toLowerCase().includes(filterTextLowerCase) ||
          liveSession.userLastname.toLowerCase().includes(filterTextLowerCase) 
      );
    }

    return filteredSessionList;
  };

  const handleFilterNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	  
    const newFilterName = e.target.value;
    setFilterName (newFilterName);
    setFilteredLiveSessionList(filterLiveSession(newFilterName));
  };

  const handleRefresh = () => {
    fetchLiveSessions({ beginningDate: startDate || undefined, endingDate: endDate || undefined });
  };

  let columns = [ 
      { header: "Date"       , accessor: "startDate"             as keyof LiveSession , width: '160px' , cellRenderer: (value: any) => (<span>{convertDateToString(value as Date, 'dd/MM/yyyy HH:mm:ss')}</span>) },
      { header: "Durée"      , accessor: "duration"              as keyof LiveSession , width: '100px' , cellRenderer: (value: any) => (<span>{formatDurationInSeconds(value as number)}</span>) },
      { header: "UserId"     , accessor: "userId"                as keyof LiveSession , width:  '80px' , cellRenderer: (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>) },
    //{ header: "Prénom"     , accessor: "userFirstname"         as keyof LiveSession , width: '150px' },
    //{ header: "Nom"        , accessor: "userLastname"          as keyof LiveSession , width: '150px' },
      { header: "Email"      , accessor: "userEmail"             as keyof LiveSession },
      { header: "Address IP" , accessor: "ipAddress"             as keyof LiveSession , width: '150px' },
    //{ header: "FAI"        , accessor: "ipAddressProviderName" as keyof LiveSession },
      { header: "Ville"      , accessor: "ipAddressCity"         as keyof LiveSession , width: '150px' },
      { header: "Pays"       , accessor: "ipAddressCountry"      as keyof LiveSession , width: '100px' },
    ];

  if (userId || userEmail) 
   {
    columns = [
      { header: "Date"       , accessor: "startDate"             as keyof LiveSession, width: '170px', cellRenderer: (value: any) => (<span>{convertDateToString(value as Date, 'dd/MM/yyyy HH:mm:ss')}</span>) },
      { header: "Durée"      , accessor: "duration"              as keyof LiveSession, width: '100px', cellRenderer: (value: any) => (<span>{formatDurationInSeconds(value as number)}</span>) },
      { header: "Address IP" , accessor: "ipAddress"             as keyof LiveSession, width: '150px' },
      { header: "FAI"        , accessor: "ipAddressProviderName" as keyof LiveSession },
      { header: "Ville"      , accessor: "ipAddressCity"         as keyof LiveSession, width: '100px' },
      { header: "Pays"       , accessor: "ipAddressCountry"      as keyof LiveSession, width: '100px' },
    ];
   }

  const generateBarGraphTitle = () : string => {

   return `Nombre de vues en live`
  }

  const generateBarGraphSubTitle = () : string => {

    const date1 = convertDateToString (startDate ,'dd/MM/yyyy HH:mm')
    const date2 = convertDateToString (endDate   ,'dd/MM/yyyy HH:mm')

    let timeStepTitle : string = ""

    for (let i =0; i<timeStepNames.length ; i++)
     {
      if ( timeStep === timeStepNames [i] )
       {
        timeStepTitle = timeStepTitles [i]
        break;
       }
     }

   return `Du ${date1} au ${date2} ${timeStepTitle}`
  }

  return (
  
    <div className={classNames(styles.root)}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}

	  {
	   userToShow !== 0 &&
	   (
  	    <Box width="95vw" height="95vh" onClose={handleClose} logo={true}>
          <UserInformations2 userId={userToShow} />
        </Box>
       )
      }
	  
      <CustomerFrontEventList key                    = { `${timeStep}`                                     }
                              startDate              = { convertDateToString(startDate,'dd/MM/yyyy HH:mm') }
                              endDate                = { convertDateToString(endDate,'dd/MM/yyyy HH:mm')   }
                              filterName             = { filterName                                        }
							  timeStep               = { timeStep                                          }
                              sessions               = { filteredLiveSessionList                           }
                              coords                 = { coordinates                                       }
                              columns                = { columns                                           }
                              handleRefresh          = { handleRefresh                                     }
                              handleDateRangeChange  = { handleDateRangeChange                             }
                              handleTimeStepChange   = { handleTimeStepChange                              }
                              handleFilterNameChange = { handleFilterNameChange                            }
                              groupedData            = { groupedData                                       }
                              chartData              = { chartData                                         }
                              barGraphTitle          = { generateBarGraphTitle()                           }
                              barGraphSubTitle       = { generateBarGraphSubTitle()                        }
                              height                 = { height                                            }
                              ready                  = { !showWaitingIcon                                  }
                              channelChoices         = {broadcastingChannelsNames                          }/>
    </div>
  );
};

export default LiveStats;
